import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import styles from './layout.module.scss';
import { Alert, IAlert, useAlertProvider } from '@cvs-web/splash-components';

const emptyAlerts: IAlert[] = [];

const PageAlerts = () => {
  const { alerts, setAlerts } = useAlertProvider();
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      setAlerts(emptyAlerts);
    }
  }, [pathname, setAlerts]);

  return (
    <div className={styles.alertsContainer}>
      {alerts.map((alert, i) => (
        <Alert
          key={i}
          title={alert.title}
          alertType={alert.type}
          footerContent={alert.actions}
          showClose={alert.showClose}
        >
          {alert.message}
        </Alert>
      ))}
    </div>
  );
};

export default PageAlerts;
